import React from "react";
import { useLocation, Route, Routes } from "react-router-dom";
import { useTheme } from "@mui/material";
import AdminNavbar from "../components/Navbars/AdminNavbar";
import Sidebar from "../components/Sidebar/Sidebar";
import CommandPalette, {
  useCommandPalette,
} from "../components/CommandPalette";
import DSBox from "views/system-design/DSBox";
import {
  APPBAR_HEIGHT,
  DRAWER_WIDTH,
  DRAWER_WIDTH_COLLAPSED,
} from "consts/layout";
import routes from "../routes";
import GiftCategories from "../views/Gifts/GiftCategories/components/GiftCategories";

const COLLAPSE_KEY = "sidebar-collapsed";

function Admin() {
  const location = useLocation();
  const { spacing, palette } = useTheme();
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(
    () => localStorage.getItem(COLLAPSE_KEY) === "1",
  );
  const palette$ = useCommandPalette();

  const toggleCollapsed = () => {
    setCollapsed((c) => {
      localStorage.setItem(COLLAPSE_KEY, c ? "0" : "1");
      return !c;
    });
  };

  // Reset scroll only when navigating to a different page. Depending on the
  // whole `location` object would also fire on query-param changes (e.g.
  // Klydoscope writing `?ticket=<id>` on row click), yanking the user back to
  // the top mid-scroll.
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  }, [location.pathname]);

  return (
    <DSBox
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: palette.background.default,
      }}
    >
      <AdminNavbar
        onMenuClick={() => setIsDrawerOpen(true)}
        onSearchClick={() => palette$.setOpen(true)}
      />
      <Sidebar
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        collapsed={collapsed}
        onToggleCollapsed={toggleCollapsed}
      />
      <CommandPalette
        open={palette$.open}
        onClose={() => palette$.setOpen(false)}
      />
      <DSBox
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          marginTop: spacing(APPBAR_HEIGHT),
          marginLeft: {
            lg: spacing(collapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH),
          },
          transition: "margin-left 0.2s ease",
          px: { xxs: 1.5, sm: 2.5, md: 4 },
          py: { xxs: 2, md: 3 },
          minHeight: `calc(100vh - ${spacing(APPBAR_HEIGHT)})`,
        }}
      >
        <Routes>
          {routes.map((i, k) => (
            <Route key={k} path={i.path} element={<i.element />} />
          ))}
          <Route path={"/gift-categories"} element={<GiftCategories />} />
        </Routes>
      </DSBox>
    </DSBox>
  );
}

export default Admin;
